import { render, staticRenderFns } from "./RiderInformation.vue?vue&type=template&id=634232be&scoped=true"
import script from "./RiderInformation.vue?vue&type=script&lang=js"
export * from "./RiderInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634232be",
  null
  
)

export default component.exports